import React, { useCallback } from "react";
import { AccrualDocuments } from "@components/documents/AccrualDocuments/AccrualDocuments";
import {
    useLinkDocumentsToBill,
    useUnlinkDocumentsFromBill,
} from "@api/bill.api";
import { useScope } from "@state/scopeContext.lib";

interface BillDocumentsProps {
    billId: string;
    financialDocumentIds?: number[];
}

export const BillDocuments: React.FC<BillDocumentsProps> = ({
    billId,
    financialDocumentIds,
}) => {
    const { workspaceId } = useScope();
    const linkMutation = useLinkDocumentsToBill();
    const unlinkMutation = useUnlinkDocumentsFromBill();

    const onLinkDocuments = useCallback(
        (documentIds: number[], options: { onError: () => void }) => {
            if (!workspaceId) {
                return;
            }
            linkMutation.mutate(
                { workspaceId, billId, financialDocumentIds: documentIds },
                { onError: options.onError },
            );
        },
        [workspaceId, billId, linkMutation],
    );

    const onUnlinkDocuments = useCallback(
        (documentIds: number[], options: { onError: () => void }) => {
            if (!workspaceId) {
                return;
            }
            unlinkMutation.mutate(
                { workspaceId, billId, financialDocumentIds: documentIds },
                { onError: options.onError },
            );
        },
        [workspaceId, billId, unlinkMutation],
    );

    return (
        <AccrualDocuments
            financialDocumentIds={financialDocumentIds}
            onLinkDocuments={onLinkDocuments}
            onUnlinkDocuments={onUnlinkDocuments}
        />
    );
};
